var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv class=\"bank-details\" ng-cloak\u003E\u003Ch2\u003EBank Details\u003C\u002Fh2\u003E\u003Cp class=\"explanation\"\u003EPlease enter the bank account details into which you would like to receive withdrawals.\u003C\u002Fp\u003E\u003Cp class=\"warning\" ng-class=\"{'make-visible': vm.noMobilePhone}\"\u003E\u003Cspan\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E You must have a \u003Cb\u003Eregistered mobile telephone number\u003C\u002Fb\u003E associated with your user to activate editing of this information.\u003C\u002Fspan\u003E\u003Cspan\u003E We use two-factor authentication via SMS to provide a higher level of security for any changes.\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Cbr\u003E \u003Cbr\u003E\u003C\u002Fspan\u003E\u003Cspan\u003EPlease contact \u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E on \u003Ctenant-anchor anchor-id=\"contact.telephone.main\"\u003E\u003C\u002Ftenant-anchor\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E for further assistance.\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Ceditable-display editable=\"vm.isEditable\" cancel-action=\"vm.resetInvestorSettings\" save-action=\"vm.saveInvestorSettings\" save-label=\"Confirm\" successful-save=\"vm.wasSaved\"\u003E\u003Cinput-container label=\"Account name\"\u003E\u003Cinput name=\"bankDetails.accountName\" data-ng-model=\"vm.investor.name\" data-ng-disabled=\"true\"\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"BSB\"\u003E\u003Cinput required name=\"bankDetails.bsb\" data-ng-model=\"vm.investor.investorSetting.bankDetails.bsb\" pattern=\"^(\\d{6}|\\d{3}[-\\s]\\d{3})$\"\u003E\u003Cng-message when=\"pattern\"\u003EInvalid BSB\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cinput-container label=\"Account number\"\u003E\u003Cinput required name=\"bankDetails.accountNumber\" data-ng-model=\"vm.investor.investorSetting.bankDetails.accountNumber\" pattern=\"[-0-9\\s]+\"\u003E\u003Cng-message when=\"pattern\"\u003EInvalid account number\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Cmd-checkbox class=\"agree\" required name=\"ownBankAccount\" ng-model=\"vm.investor.investorSetting.bankDetails.ownBankAccount\" aria-label=\"Owns?\" ng-disabled=\"vm.isFormDisabled()\"\u003EThe bank account above is in the name of \u003Cb\u003E\u003Ci\u003E{{ vm.investor.name }}\u003C\u002Fi\u003E\u003C\u002Fb\u003E\u003C\u002Fmd-checkbox\u003E\u003Cp ng-if=\"vm.wasSaved\"\u003EYour bank account details have been successfully entered. If you wish to request a withdrawal you can can do so \u003Ca ng-click=\"closeDialog()\" ui-sref=\"investorDashboard.manageFunds\"\u003Ehere\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Feditable-display\u003E\u003C\u002Fdiv\u003E";
}
});}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;